var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTaxes = function SvgTaxes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C10.866 0 14 3.134 14 7C14 10.866 10.866 14 7 14C3.134 14 0 10.866 0 7C0 3.134 3.134 0 7 0ZM7 2.8C6.641 2.8 6.34514 3.07023 6.30471 3.41836L6.3 3.5V4.2H5.6C4.6335 4.2 3.85 4.9835 3.85 5.95C3.85 6.87783 4.57208 7.63703 5.48494 7.69628L5.6 7.7H6.3V8.4H4.9C4.5134 8.4 4.2 8.71339 4.2 9.1C4.2 9.45899 4.47023 9.75486 4.81837 9.79529L4.9 9.8H6.3V10.5C6.3 10.8866 6.61339 11.2 7 11.2C7.35899 11.2 7.65486 10.9298 7.69529 10.5816L7.7 10.5V9.8H8.4C9.36649 9.8 10.15 9.01649 10.15 8.05C10.15 7.12217 9.42792 6.36297 8.51506 6.30372L8.4 6.3H7.7V5.6H9.1C9.48661 5.6 9.8 5.2866 9.8 4.9C9.8 4.54102 9.52978 4.24515 9.18164 4.20471L9.1 4.2H7.7V3.5C7.7 3.1134 7.38661 2.8 7 2.8ZM8.4 7.7C8.59327 7.7 8.75 7.85673 8.75 8.05C8.75 8.24327 8.59327 8.4 8.4 8.4H7.7V7.7H8.4ZM6.3 5.6V6.3H5.6C5.4067 6.3 5.25 6.14327 5.25 5.95C5.25 5.75673 5.4067 5.6 5.6 5.6H6.3Z",
    fill: "#232323"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTaxes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/taxes.c33a9efc.svg";
export { ForwardRef as ReactComponent };